import { render, staticRenderFns } from "./sdgGoalSelector.vue?vue&type=template&id=3c54a54c&scoped=true"
import script from "./sdgGoalSelector.vue?vue&type=script&lang=js"
export * from "./sdgGoalSelector.vue?vue&type=script&lang=js"
import style0 from "./sdgGoalSelector.vue?vue&type=style&index=0&id=3c54a54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c54a54c",
  null
  
)

export default component.exports